export enum TemplateType {
  ORGANIZATION = 'My Organization', PUBLIC = 'Zitles Bank'
}